import { render, staticRenderFns } from "./email_marketing.vue?vue&type=template&id=6d882c30"
import script from "./email_marketing.vue?vue&type=script&lang=js"
export * from "./email_marketing.vue?vue&type=script&lang=js"
import style0 from "./email_marketing.vue?vue&type=style&index=0&id=6d882c30&prod&lang=css"
import style1 from "./email_marketing.vue?vue&type=style&index=1&id=6d882c30&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports